import { gql } from 'graphql-request';

export const CLEAR_PRODUCTS_CACHE_QUERY = gql`
  mutation ClearProductsCache($async: Boolean, $source: String) {
    clearProductsCache(input: { async: $async, source: $source }) {
      status
    }
  }
`;
